export default __webpack_public_path__ + "static/media/ana-grenade.f80883bc.mp3";